import type { SalesforceProjectMember } from 'backend/types'

export function filterMembers(members: SalesforceProjectMember[], searchText: string): SalesforceProjectMember[] {
  if (!searchText.trim()) return members

  const searchLower = searchText.toLowerCase()
  return members.filter(
    (member) =>
      member.memberName.toLowerCase().includes(searchLower) ||
      member.salesforceProjectMemberTypeName.toLowerCase().includes(searchLower) ||
      member.employeeNumber?.toString().includes(searchText),
  )
}
